/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VAddCaddyRequestParams
 */
export interface VAddCaddyRequestParams {
    /**
     * Serial of the caddy
     * @type {string}
     * @memberof VAddCaddyRequestParams
     */
    serial: string;
    /**
     * Clinic Id the caddy belongs to
     * @type {string}
     * @memberof VAddCaddyRequestParams
     */
    clinicId?: string;
    /**
     * Firmware version Id of the caddy
     * @type {string}
     * @memberof VAddCaddyRequestParams
     */
    targetFirmwareVersionId?: string;
    /**
     * Low battery threshold
     * @type {number}
     * @memberof VAddCaddyRequestParams
     */
    lowBatteryThreshold?: number;
    /**
     * Critical battery threshold
     * @type {number}
     * @memberof VAddCaddyRequestParams
     */
    criticalBatteryThreshold?: number;
}

/**
 * Check if a given object implements the VAddCaddyRequestParams interface.
 */
export function instanceOfVAddCaddyRequestParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "serial" in value;

    return isInstance;
}

export function VAddCaddyRequestParamsFromJSON(json: any): VAddCaddyRequestParams {
    return VAddCaddyRequestParamsFromJSONTyped(json, false);
}

export function VAddCaddyRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VAddCaddyRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serial': json['serial'],
        'clinicId': !exists(json, 'clinicId') ? undefined : json['clinicId'],
        'targetFirmwareVersionId': !exists(json, 'targetFirmwareVersionId') ? undefined : json['targetFirmwareVersionId'],
        'lowBatteryThreshold': !exists(json, 'lowBatteryThreshold') ? undefined : json['lowBatteryThreshold'],
        'criticalBatteryThreshold': !exists(json, 'criticalBatteryThreshold') ? undefined : json['criticalBatteryThreshold'],
    };
}

export function VAddCaddyRequestParamsToJSON(value?: VAddCaddyRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serial': value.serial,
        'clinicId': value.clinicId,
        'targetFirmwareVersionId': value.targetFirmwareVersionId,
        'lowBatteryThreshold': value.lowBatteryThreshold,
        'criticalBatteryThreshold': value.criticalBatteryThreshold,
    };
}

